<template>
  <div class="breadcrumbs">
    <span class="crumb" v-for="(crumb, index) in breadcrumbs" v-bind:key="crumb.label + index">
      <button class="crumb-link" @click="move(crumb)" :class="{'current-crumb': crumb.current}" v-html="crumb.label">
      </button>
      <span class="limiter" v-if="index < breadcrumbs.length - 1">
        <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    ignoreCurrent: Boolean,
    breadcrumbsInfo: null
  },
  data: function() {
    return {
      breadcrumbs: []
    }
  },
  watch: {
    $route: function() {
      this.init()
    },
    'breadcrumbsInfo': function(to, from) {
      this.breadcrumbs = to
    }
  },
  created() {
    this.init()
  },
  methods: {
    move(crumb) {
      if (crumb.current) {
        return
      }
      this.$store.commit('busy')
      if (crumb.home) {
        this.$store.dispatch('home')
          .then(() => {
            if (this.$router.history.current.meta.requireRedirectForHome) {
              this.$router.replace(crumb.path)
            } else {
              this.$router.go(0) // refresh
            }
          })
      } else if (crumb.back) {
        crumb.back(crumb.undoCount)
      } else {
        this.$router.replace(crumb.path)
      }
    },
    init: function() {
      if (this.breadcrumbsInfo && this.breadcrumbsInfo.length > 0) {
        this.breadcrumbs = this.breadcrumbsInfo
      } else {
        let breadcrumbs = []
        if (this.$route.meta.breadcrumbs) {
          breadcrumbs = [...this.$route.meta.breadcrumbs]
        }
        if (!this.ignoreCurrent) {
          let currentPath = this.$route.path.split('/')
          currentPath = currentPath[currentPath.length - 1]
          if (currentPath.length > 15) {
            currentPath = currentPath.slice(0, 15) + '...'
          }
          breadcrumbs.push({label: currentPath.replaceAll('-', ' '), path: {}, home: false, current: true})
        }
        this.breadcrumbs = breadcrumbs
      }
    }
  }
}
</script>

<style scoped lang="less">
  .breadcrumbs {
    margin: 12px 5px 0;

    .crumb {
      margin-right: 2px;
      outline: none;
    }

    .limiter {
      margin-left: 2px;
      font-size: 14px;

      svg {
        color: #212529 !important;
      }
    }

    .crumb-link {
      background: none;
      border: none;
      color: var(--theme_color);
      text-transform: capitalize;
      font-size: 12px;
    }

    .current-crumb {
      color: #6a6a6a;
      cursor: unset;

      &:first-letter {
        text-transform: uppercase;
      }
    }

    @media only screen and (min-width: 501px) {
      .limiter {
        margin-left: 10px;
      }

      .crumb {
        margin-right: 10px;
      }
      .crumb-link {
        font-size: 14px;
      }
    }
  }
</style>
